<template>
  <div>
    <div v-if="!load_first">
      <jLoadingTable/>
    </div>
    <div v-show="load_first">
      <v-server-table
        ref="flowServer"
        :url="env"
        :columns="columns"
        :options="options"
        class="jTable"
        @loading="loading"
        @loaded="loaded"
        @row-click="rowClick"
        @pagination="removeRowBackground">

        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <j-select
              v-model="select_type"
              :disabled="false"
              :options="options_search"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="search"
              class="m__r--5"/>
            <b-button
              class="btn grey btn-import-form"
              @click="filter(filter_data)">
              <i class="fa fa-search bold" /> Search
            </b-button>
          </b-form>
        </div>
        <div
          slot="sla_policy"
          slot-scope="props">
          <div
            v-for="policy in props.row.sla"
            :key="policy.id">
            Type {{ policy.type - 1 }} value ({{ policy.value }}%)
          </div>
        </div>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import { jFlowSLA } from '@/mixins/paginations/flow/jFlowSLA';

export default {
  // eslint-disable-next-line
  name: 'jFlowSLA',
  components: {
    jLoadingTable,
  },
  mixins: [
    jFlowSLA,
  ],
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {
    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },
  created() {

  },
  methods: {
    rowClick(data) {
      this.$store.commit('jStoreFlows/setDetailSLA', { data: data.row });
      this.$store.commit('jStoreFlows/setOpenSLA');
      this.$router.replace(`/flows/sla/edit/${data.row.id}`);
    },
    removeRowClick() {

    },
    removeRowBackground() {

    },
  },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-sla/list/jListFlowSLA.vue